module.exports = __webpack_public_path__ + "img/a2-s44.f0741ad3.jpg";